import { EnumTrans, UnitTrans } from "@/i18n/trans"

export const transMixin = {
    computed: {
        $enumTrans() {
            return new EnumTrans(this)
        },
        $unitTrans() {
            return new UnitTrans(this)
        }
    }
}
declare module 'vue/types/vue' {
    interface Vue {
        $enumTrans: EnumTrans
        $unitTrans: UnitTrans
    }
}

export const transMixinApi = Vue => {
    Object.defineProperties(Vue.prototype, {
        $enumTrans: {
            get() {
                return new EnumTrans(this)
            }
        },
        $unitTrans: {
            get() {
                return new UnitTrans(this)
            },
        }
    })
}